import { Injectable } from "@angular/core";
import { MeetingRoomKioskStatus } from "../models/kiosk.model";

/**
 * Service to handle LED status activation for meeting room kiosk
 * This service provides methods to control the LED status indicators
 * used by the mobile wrapper to change the physical LED lights on the device.
 */
@Injectable({
  providedIn: "root",
})
export class LedActivationService {
  setLedSetupStatus(): void {
    console.log("LED_STATUS: SETUP");
  }

  setLedSetupInProgressStatus(): void {
    console.log("LED_STATUS: SETUP_IN_PROGRESS");
  }

  setRoomLedStatus(status: MeetingRoomKioskStatus): void {
    switch (status) {
      case MeetingRoomKioskStatus.FREE:
        console.log("LED_STATUS: AVAILABLE");
        break;
      case MeetingRoomKioskStatus.CHECK_IN:
        console.log("LED_STATUS: PENDING_CHECK_IN");
        break;
      case MeetingRoomKioskStatus.OCCUPIED:
        console.log("LED_STATUS: OCCUPIED");
        break;
    }
  }
}
